export type ClientRole = 'admin' | 'manager' | 'internal' | 'external';

export interface UserDto {
  id: string;
  email: string | null;
  userName: string | null;
  displayName: string | null;
  initials: string | null;
  clientRole: ClientRole | null;
  isAdmin: boolean;
}

export interface CurrentUser {
  id: string;
  email: string | null;
  userName: string | null;
  displayName: string | null;
  initials: string;
  clientRole: ClientRole | null;
  isAdmin: boolean;
}

export function mapUser(dto: UserDto): CurrentUser {
  return {
    id: dto.id,
    email: dto.email,
    userName: dto.userName,
    displayName: dto.displayName,
    initials: dto.initials ?? '??',
    clientRole: dto.clientRole ?? null,
    isAdmin: dto.isAdmin,
  };
}
